import React, { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";

const fsEl = () => document.fullscreenElement || document.webkitFullscreenElement;

export function PlayableVideo({ src, className = "" }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const wasFs = useRef(false);
  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    const exit = () => {
      if (fsEl() === v) { wasFs.current = true; return; }
      if (wasFs.current) { wasFs.current = false; v.pause(); setPlaying(false); }
    };
    const iosExit = () => { v.pause(); setPlaying(false); };
    document.addEventListener("fullscreenchange", exit);
    document.addEventListener("webkitfullscreenchange", exit);
    v.addEventListener("webkitendfullscreen", iosExit);
    return () => {
      document.removeEventListener("fullscreenchange", exit);
      document.removeEventListener("webkitfullscreenchange", exit);
      v.removeEventListener("webkitendfullscreen", iosExit);
    };
  }, []);
  const play = (e) => {
    e.stopPropagation();
    const v = ref.current;
    v.muted = false;
    v.controls = true;
    setPlaying(true);
    const p = v.play();
    if (v.requestFullscreen) v.requestFullscreen().catch(() => {});
    else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
    else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
    p?.catch?.(() => { v.controls = false; setPlaying(false); });
  };
  return (
    <div className="relative h-full w-full">
      <video ref={ref} src={`${src}#t=0.1`} playsInline preload="metadata" controls={playing} onEnded={() => setPlaying(false)} className={`h-full w-full object-contain bg-black ${className}`} data-testid="preview-video" />
      {!playing && (
        <button type="button" data-testid="preview-video-play" onClick={play} aria-label="Play video full screen" className="absolute inset-0 flex items-center justify-center bg-black/10 group">
          <span className="h-16 w-16 rounded-full bg-white/90 shadow-lg flex items-center justify-center transition-transform group-hover:scale-105 group-active:scale-95"><Play className="h-7 w-7 text-[#06060C] ml-1" fill="currentColor" /></span>
        </button>
      )}
    </div>
  );
}
